
import { BrokerListConfig } from 'main/content/report/brokerList/BrokerListConfig';
import { BrokerWiseSaleConfig } from 'main/content/report/brokerWiseSale/BrokerWiseSaleConfig';
import { CategoryWiseSaleConfig } from 'main/content/report/categoryWiseSale/CategoryWiseSaleConfig';
import { CustomerListConfig } from 'main/content/report/customerList/CustomerListConfig';
import { CustomerWiseSaleConfig } from 'main/content/report/customerWiseSale/CustomerWiseSaleConfig';
import { DailySalesCollectionConfig } from 'main/content/report/dailySalesCollection/DailySalesCollectionConfig';
import { EmployeeWiseTaskConfig } from 'main/content/report/employeeWiseTask/EmployeeWiseTaskConfig';
import { irdReportConfigs } from 'main/content/report/irdReport/irdReportConfigs';
import { CalibrationListConfig } from './calibration/CalibrationListConfig';

export const ReportConfig = [
    CustomerListConfig,
    CategoryWiseSaleConfig,
    BrokerWiseSaleConfig,
    EmployeeWiseTaskConfig,
    BrokerListConfig,
    DailySalesCollectionConfig,
    CustomerWiseSaleConfig,
    irdReportConfigs,
    CalibrationListConfig
];





// WEBPACK FOOTER //
// ./src/main/content/report/reportRoutesConfig.js